<template>
  <div class="container">
    <div class="titleBox">
      <div class="title">
        <span class="tips"><i>{{ $t("person.letter.tips.tip1") }}</i>{{ $t("person.letter.tips.tip2") }}</span>
        <span class="tip">{{ $t("person.letter.tips.tip3") }}</span>
      </div>
    </div>
    <div class="main">
      <div class="head">{{ info.title + form.name + ":" }}</div>
      <div class="tipInfo">
        <div class="tip1">{{ info.tip1 }}{{ info.tip2 }}</div>
        <div class="tip2">{{ info.tip3 }}</div>
      </div>
      <div class="visitInfoRegister">
        <div class="button">
          {{ $t("person.letter.infos.info1") }}
        </div>
        <el-form :model="form">
          <el-form-item :label="$t('person.baseInfos.name')">
            {{ form.name }}
          </el-form-item>
          <el-form-item :label="$t('person.letter.company')">
            {{ form.company }}
          </el-form-item>
          <el-form-item :label="$t('person.baseInfos.duty')">
            {{ form.duty }}
          </el-form-item>
          <el-form-item :label="$t('person.letter.phone')">
            {{ form.registAccount }}
          </el-form-item>
          <el-form-item :label="$t('person.baseInfos.email')">
            {{ form.email }}
          </el-form-item>
          <!-- <el-form-item label="二维码：">
            <img :src="baseUrl + form.column23" alt="" />
          </el-form-item> -->
        </el-form>
      </div>
      <div class="loginInfo">
        <div class="button">
          {{ $t("person.letter.infos.info2") }}
        </div>
        <el-form :model="form">
          <el-form-item :label="$t('person.letter.registAccount')">
            {{ form.registAccount }}
          </el-form-item>
          <el-form-item :label="$t('person.letter.password')">
            {{ form.cause }}
          </el-form-item>
        </el-form>
        <span class="littleTip"
          ><i>{{ $t("person.letter.tips.tip1") }}</i>{{$t('mobile.editRegisMessage')}}
          <span class="click" @click="editMessage()">{{$t('mobile.clickHereL')}}</span>{{$t('mobile.logBackManage')}}</span>
      </div>
      <div class="visitInfo">
        <div class="button">
          {{ $t("person.letter.infos.info3") }}
        </div>
        <el-form :model="info">
          <el-form-item>
          
           <div class="boxI">
                <div slot="label" class="label">
                {{$t('person.letter.time')}}
            </div>

              <div class="Timer">
                     <div>{{ info.time1 }}</div>
                     <div>{{ info.time2 }}</div>
              </div>
           </div>
       
          </el-form-item>
          <el-form-item :label="$t('person.letter.address')">
            {{ info.address }}
          </el-form-item>
          <el-form-item :label="$t('person.letter.position')">
            {{ info.position }}
          </el-form-item>
        </el-form>
        <div class="imgInfo">
          <span class="span1">{{ $t("person.letter.img") }}</span>
          <div>
            <div v-if="clickM" @click="clickMore()" class="clickMore">
              {{$t('mobile.clickLook')}}
            </div>
            <el-image
              v-else
              style="width:230px; height: 180px"
              :src="img"
              :preview-src-list="srcList"
            >
            </el-image>
          </div>
        </div>
      </div>
      <div class="consultInfo">
        <div class="button">{{ $t("person.letter.infos.info4") }}</div>
        <div class="companyName">{{ $t("person.letter.companyName") }}</div>

        <el-form :model="info">
          <el-form-item :label="$t('person.letter.contacts')">
            {{ info.linkPerson }}
          </el-form-item>
          <el-form-item :label="$t('person.letter.telephone')">
            {{ info.phone }}
          </el-form-item>
          <el-form-item :label="$t('person.baseInfos.email')">
            {{ info.email }}
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { getConfirmation } from "../../../../api/personInfo.js";
import { forMat } from "../../../../utils/common.js";
import img from "../../../static/boothAddress.jpg";
export default {
  data() {
    return {
      img: img,
      srcList: [img],
      baseUrl: forMat(),
      info: {
        title: this.$t("person.letter.informations.title"),
        tip1: this.$t("person.letter.informations.tip1"),
        tip2: this.$t("person.letter.informations.tip2"),
        tip3: this.$t("person.letter.informations.tip3"),
        time1: this.$t("person.letter.informations.time1"),
        time2: this.$t("person.letter.informations.time2"),
        address: this.$t("person.letter.informations.address"),
        position: this.$t("person.letter.informations.position"),
        linkPerson: this.$t("person.letter.informations.linkPerson"),
        phone: this.$t("person.letter.informations.phone"),
        email: this.$t("person.letter.informations.email"),
      },
      form: {
        name: "", //姓名
        company: "", //公司
        duty: "", //职位
        registAccount: "", //手机号
        email: "", //邮箱
        column23: "", //二维码
        cause: "", //密码
      },
      lang: "",
      clickM: true, //展位图查看更多
    };
  },
  created() {
    this.getInfo();
    this.lang = localStorage.getItem("lang");
  },
  methods: {
    async getInfo() {
      try {
        const { data } = await getConfirmation();
        if (data.code === 200) {
          this.form = data.data;
          // this.form.column23 = '/hz/userfiles/upload/image/20190823/p1diu1jauc163o1na713n2p9e88oh.JPG';
          // 测试数据 二维码
        }
      } catch (err) {
        console.log(err.message);
      }
    },
    //修改个人信息
    editMessage() {
      this.$router.push({ path: "/adminLogin" });
      sessionStorage.clear(); //清空sessionStorage的存储信息
      this.$router.push({ name: "adminLogin" });
      localStorage.removeItem("audienceInfo"); //移除登录用户信息
      localStorage.removeItem("viewToken"); //移除观众的token
      localStorage.removeItem("lang"); //移出语言记录
    },
    clickMore() {
      this.clickM = !this.clickM;
    },
  },
  watch: {
    lang(newValue, oldValue) {
      if (newValue == "en") {
        this.lang = "en";
      }
      if (newValue == "zh") {
        this.lang = "zh";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  .titleBox {
    background-color: white;
    padding: 1px 15px 0px 15px;
    box-sizing: border-box;
    position: relative;
    top: 25px;

    .title {
      background: #f6f6f7;
      line-height: 15px;
      margin-top: 25px;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-start;
      .tips {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff190c;
        line-height: 17px;
        padding-right: 5px;
        box-sizing: border-box;
        i {
          font-style: normal;
          margin-right: 5px;
        }
      }
      .tip {
        flex: 1;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 15px;
        box-sizing: border-box;
      }
    }
  }

  .main {
    background-color: white;
    padding: 25px 15px 0px 15px;
    box-sizing: border-box;
    margin-top: 25px;
    .head {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .tipInfo {
      margin-top: 30px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 18px;

      .tip1 {
        color: #333333;
      }
      .tip2 {
        color: #ff190c;
        margin-top: 20px;
      }
    }
    .visitInfoRegister {
      margin-top: 40px;
      .button {
        text-align: left;
        background: #006fb8;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
        padding: 2px 7px;
        box-sizing: border-box;
        width: fit-content;
      }
      img {
        width: 100px;
        height: 100px;
        background: #d8d8d8;
      }
    }
    .loginInfo {
      margin-top: 25px;
      .button {
        text-align: left;
        padding-left: 10px;
        background: #006fb8;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
        padding: 2px 10px 2px 10px;
        box-sizing: border-box;
        width: fit-content;
      }
      .littleTip {
        i {
          color: #ff190c;
          margin-right: 5px;
        }
        .click {
          color: #006fb8;
        }
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 17px;
        padding-top: 10px;
        display: block;
        color: #999999;
      }
    }
    .visitInfo {
      margin-top: 25px;
      .button {
        text-align: left;
        padding-left: 10px;
        background: #006fb8;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
        padding: 2px 10px 2px 10px;
        box-sizing: border-box;
        width: fit-content;
      }
      .imgInfo {
        margin-top: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 22px;
        display: flex;
        .span1 {
          color: #333333;
          display: block;
          font-weight: 600;
        }
        .clickMore {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #006fb8;
        }
        .span2 {
          color: #006fb8;
          font-size: 16px;
        }
      }
    }
    .consultInfo {
      margin-top: 25px;
      padding-bottom: 25px;
      .button {
        text-align: center;
        width: 76px;
        height: 24px;
        background: #006fb8;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
      }
      .companyName {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        margin-top: 10px;
        margin-bottom: 10px;
        font-weight: 600;
      }
    }
  }
}
.button {
  margin-bottom: 15px;
}
.boxI{
   display: flex;
   justify-content: flex-start;
}

</style>
<style scoped>
.el-form-item {
  margin-bottom: 0px;
}
.container >>> .el-form-item__label {
  font-weight: 600;
  line-height: 30px;
  padding: 0px;
}
.container >>> .el-form-item__content {
  font-weight: 600;
  line-height: 30px;
}
.container >>> .el-form {
  padding-top: 0px !important;
}
</style>
